export default __webpack_public_path__ + "static/media/service-thumb-block-retaining-wall.496d9f6c.jpg";